import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PostListType } from 'gnx-social-network-wcomponent';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';

@Component({
  selector: 'app-social-post-by-hashtag',
  templateUrl: './social-post-by-hashtag.page.html',
  styleUrls: ['./social-post-by-hashtag.page.scss'],
})
export class SocialPostByHashtagPage implements OnInit {
  sub: any;
  postType: PostListType; /*  = PostListType.HASHTAG; */
  hashtagPath: string; /*  = 'user-info/56527715712363333'; */


  constructor(public languageService: LanguagesService, private route: ActivatedRoute) {}

  ngOnInit() {
    this.sub = this.route.queryParamMap.subscribe((queryParamMap) => {
      // Defaults to 0 if no query param provided.
      // console.log('params:', params);
      this.postType = PostListType.HASHTAG;
      const path = queryParamMap.get('path');
      this.hashtagPath = path;
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  get getTextIUPageSocialHashtag() {
    return this.languageService.textsIU.page_social_hashtag;
  }

}
